import React, { useEffect, useState } from "react";
import { Main, Content } from "../../../components/Layout";
import api from "../../../services/api";
import { ChartsBar } from "../../../components/Charts";
import { Col, Row } from "react-bootstrap";
import Slct from "../../../components/Slct";
import getCommercial from "../../../util/getCommercial";
import { PrintPage } from "../../../components/PrintPage";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import StatusFlag from "../../../components/StatusFlag";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import IcArrow from "../../../components/Svg/IcArrow";
import useFormat from "../../../hooks/utils/useFormat";

export default function ReportsTrainees() {
  const { me, config, setbreadcrumb } = useWrapper();

  const [groups, setgroups] = useState([]);
  const [loading, setloading] = useState(false);
  const [dateOrder, setdateOrder] = useState();
  const { sortObject, formatDate } = useFormat();

  const [filter, setFilter] = useState({
    "Tipo de Resultados": "Aceite Virtual",
    Turma: { value: "", label: "-- Todas --" },
    acesso: "",
    vinculo: "",
    comissao: "",
  });
  const [reports, setReports] = useState({
    data: [],
    title: "",
    type: "",
  });
  useEffect(() => {
    (async function () {
      setloading(true);
      if (filter["Tipo de Resultados"] === "Aceite Virtual") {
        const _trainees = await api.get(
          `trainees/general/report/?joins=commercials.institution,commercials.course&commercial_id=${filter["Turma"].value}&cancel=${filter["vinculo"]}&active=${filter["acesso"]}&is_member=${filter["comissao"]}`,
          config,
        );
        let responseVar = [..._trainees.data];

        let tableVar = [];
        let aceitein = 0;
        let aceiteNot = 0;
        responseVar.forEach((e, index) => {
          if (e.aceite_virtual === 1) {
            aceitein++;
          } else {
            aceiteNot++;
          }
          tableVar.push({
            Turma: e.commercials
              ? `${e.commercials.course ? e.commercials.course.title : ""} ${e.commercials.year}.${
                  e.commercials.period
                } (${e.commercials.institution ? e.commercials.institution.title : ""})`
              : "-",
            Formando: e.name,
            Comissao: e.is_member ? "Sim" : "Não",
            Criado: e.created_at,
            Acesso: e.active ? "Autorizado" : "Revogado",
            Vinculo: !e.cancel ? "Ativo" : "Encerrado",
            Id: e.id,
            "Data do Aceite": e.date_aceite,
            "Aceite Virtual": e.aceite_virtual === 1 ? "Sim" : "Não",
            type: e.id,
            color: e.aceite_virtual === 1 ? 1 : 2,
            colorCancel: !!e.cancel ? 2 : 1,
            colorActive: !!e.active ? 1 : 2,
            colorComissio: !!e.is_member ? 1 : 2,
          });
        });
        setReports({
          data: [
            {
              label: "Aceite Virtual",
              value: aceitein,
            },
            {
              label: "Sem Aceite Virtual",
              value: aceiteNot,
            },
          ],
          title: "Status do Aceite Virtual",
          type: "fomandos",
          table: tableVar,
        });
      } else if (filter["Tipo de Resultados"] === "Sem financeiro") {
        const _trainees = await api.get(
          `trainees/general/report/?joins=commercials.institution,commercials.course&commercial_id=${filter["Turma"].value}&cancel=${filter["vinculo"]}&active=${filter["acesso"]}&is_member=${filter["comissao"]}`,
          config,
        );
        let responseVar = [..._trainees.data];

        let tableVar = [];
        let financialin = 0;
        let financialNot = 0;
        responseVar.forEach((e, index) => {
          if (e.financial_released === 1) {
            financialin++;
          } else {
            financialNot++;
          }
          tableVar.push({
            Turma: e.commercials
              ? `${e.commercials.course ? e.commercials.course.title : ""} ${e.commercials.year}.${
                  e.commercials.period
                } (${e.commercials.institution ? e.commercials.institution.title : ""})`
              : "-",
            Formando: e.name,
            Comissao: e.is_member ? "Sim" : "Não",
            Criado: e.created_at,
            Acesso: e.active ? "Autorizado" : "Revogado",
            Vinculo: !e.cancel ? "Ativo" : "Encerrado",
            "Financeiro Lançado": e.financial_released === 1 ? "Sim" : "Não",
            Id: e.id,
            type: e.id,
            color: e.financial_released === 1 ? 1 : 2,
            colorCancel: !!e.cancel ? 2 : 1,
            colorActive: !!e.active ? 1 : 2,
            colorFinancial: !!e.financial_released ? 1 : 2,
            colorComissio: !!e.is_member ? 1 : 2,
          });
        });
        setReports({
          data: [
            {
              label: "Financeiro",
              value: financialin,
            },
            {
              label: "Sem Financeiro",
              value: financialNot,
            },
          ],
          title: "Status do Financeiro",
          type: "fomandos",
          table: tableVar,
        });
      } else if (filter["Tipo de Resultados"] === "Contrato Assinado") {
        const _traines = await api.get(
          `trainees/general/report/?joins=commercials.institution,commercials.course&commercial_id=${filter["Turma"].value}&cancel=${filter["vinculo"]}&active=${filter["acesso"]}&is_member=${filter["comissao"]}`,
          config,
        );
        let responseVar = [..._traines.data];

        let tableVar = [];
        let contractin = 0;
        let contractNot = 0;
        responseVar.forEach((e, index) => {
          if (!!e.contract_date) {
            contractin++;
          } else {
            contractNot++;
          }
          tableVar.push({
            Turma: e.commercials
              ? `${e.commercials.course ? e.commercials.course.title : ""} ${e.commercials.year}.${
                  e.commercials.period
                } (${e.commercials.institution ? e.commercials.institution.title : ""})`
              : "-",
            Formando: e.name,
            Comissao: e.is_member ? "sSm" : "Não",
            Criado: e.created_at,
            Acesso: e.active ? "Autorizado" : "Revogado",
            Vinculo: !e.cancel ? "Ativo" : "Encerrado",
            "Contrato Assinado": !!e.contract_date ? "Sim" : "Não",
            "Data do Contrato": e.contract_date,
            type: e.id,
            Id: e.id,
            color: !!e.contract_date ? 1 : 2,
            colorCancel: !!e.cancel ? 2 : 1,
            colorActive: !!e.active ? 1 : 2,
            colorComissio: !!e.is_member ? 1 : 2,
          });
        });
        setReports({
          data: [
            {
              label: "Contrato Assinado",
              value: contractin,
            },
            {
              label: "Contrato não Assinado",
              value: contractNot,
            },
          ],
          title: "Status da Assinatura de Contrato",
          type: "fomandos",
          table: tableVar,
        });
      } else if (filter["Tipo de Resultados"] === "Ativos") {
        const _traines = await api.get(
          `trainees/general/report/?joins=commercials.institution,commercials.course&commercial_id=${filter["Turma"].value}&cancel=${filter["vinculo"]}&active=${filter["acesso"]}&is_member=${filter["comissao"]}`,
          config,
        );
        let responseVar = [..._traines.data];

        let tableVar = [];
        let cancelUser = 0;
        let activeuser = 0;
        responseVar.forEach((e, index) => {
          if (!e.cancel) {
            activeuser++;
          } else {
            cancelUser++;
          }
          tableVar.push({
            Turma: e.commercials
              ? `${e.commercials.course ? e.commercials.course.title : ""} ${e.commercials.year}.${
                  e.commercials.period
                } (${e.commercials.institution ? e.commercials.institution.title : ""})`
              : "-",
            Formando: e.name,
            Comissao: e.is_member ? "Sim" : "Não",
            Criado: e.created_at,
            Acesso: e.active ? "Autorizado" : "Revogado",
            Vinculo: !e.cancel ? "Ativo" : "Encerrado",
            "Contrato Assinado": !!e.contract_date ? "Sim" : "Não",
            "Data do Contrato": e.contract_date,
            type: e.id,
            Id: e.id,
            colorCancel: !!e.cancel ? 2 : 1,
            colorActive: !!e.active ? 1 : 2,
            colorComissio: !!e.is_member ? 1 : 2,
          });
        });
        setReports({
          data: [
            {
              label: "Ativo",
              value: activeuser,
            },
            {
              label: "Encerrado",
              value: cancelUser,
            },
          ],
          title: "Status de Acesso dos Formandos",
          type: "fomandos",
          table: tableVar,
        });
      } else if (filter["Tipo de Resultados"] === "Por Pacote") {
        const _traines = await api.get(
          `trainees/general/report/?joins=commercials.institution,commercials.course,packages,packageSingle.event&commercial_id=${filter["Turma"].value}&cancel=${filter["vinculo"]}&active=${filter["acesso"]}&is_member=${filter["comissao"]}`,
          config,
        );
        let responseVar = [..._traines.data];

        let tableVar = [];
        let cancelUser = 0;
        let activeuser = 0;
        responseVar.forEach((e, index) => {
          if (!e.cancel) {
            activeuser++;
          } else {
            cancelUser++;
          }
          tableVar.push({
            Turma: e.commercials
              ? `${e.commercials.course ? e.commercials.course.title : ""} ${e.commercials.year}.${
                  e.commercials.period
                } (${e.commercials.institution ? e.commercials.institution.title : ""})`
              : "-",
            Formando: e.name,
            Comissao: e.is_member ? "Sim" : "Não",
            Criado: e.created_at,
            Acesso: e.active ? "Autorizado" : "Revogado",
            Vinculo: !e.cancel ? "Ativo" : "Encerrado",
            Pacotes: e.packages.length ? e.packages.map(obj => obj.name).join(", ") : "-",
            "Eventos Avulsos": e.packageSingle.length ? e.packageSingle.map(obj => obj.event.name).join(", ") : "-",
            type: e.id,
            Id: e.id,
            colorCancel: !!e.cancel ? 2 : 1,
            colorActive: !!e.active ? 1 : 2,
            colorComissio: !!e.is_member ? 1 : 2,
          });
        });
        setReports({
          data: [
            {
              label: "Ativo",
              value: activeuser,
            },
            {
              label: "Encerrado",
              value: cancelUser,
            },
          ],
          title: "Status de Acesso dos Formandos",
          type: "fomandos",
          table: tableVar,
        });
      }
      try {
        switch (filter["Tipo de Resultados"]) {
          default:
          case "Aceite Virtual":
            break;
          case "Sem financeiro":
            break;
          case "Contrato Assinado":
            break;
        }
      } catch (__err) {
        toast.error("Problemas ao tentar carregar o relatório");
        console.log("__err", __err);
      }
      setloading(false);
    })();
  }, [filter]);

  useEffect(() => {
    getCommercial(null, null, "?").then(resp => {
      setgroups(
        [
          {
            value: "",
            label: "-- Todas --",
          },
        ].concat(resp),
      );
    });
  }, []);

  useEffect(() => {
    setbreadcrumb([{ label: "Relatórios" }]);
  }, []);

  return (
    <PrintPage has_logo={true} signed_by={me.username}>
      <Main>
        <Content>
          <Row>
            <Col>
              <div className="d-flex justify-content-between">
                <h2 className="page-title">Relatórios de Formandos</h2>
                <div className="d-flex ml-4">
                  <PrintPage.PrintButton label="Gerar PDF" />
                  <PrintPage.CSVButton
                    label="Gerar CSV"
                    title={reports.title}
                    overview={reports.data}
                    table={reports?.table?.map(_row => ({
                      ...(_row["Formando"] !== undefined && {
                        Formando: _row["Formando"],
                      }),
                      ...(_row["Turma"] !== undefined && {
                        Turma: _row["Turma"].label,
                      }),
                      ...(_row["Aceite Virtual"] !== undefined && {
                        "Aceite Virtual": _row["Aceite Virtual"],
                      }),
                      ...(_row["Data do Aceite"] !== undefined && {
                        "Data do Aceite": _row["Data do Aceite"],
                      }),
                      ...(_row["Financeiro Lançado"] !== undefined && {
                        "Financeiro Lançado": _row["Financeiro Lançado"],
                      }),
                      ...(_row["Contrato Assinado"] !== undefined && {
                        "Contrato Assinado": _row["Contrato Assinado"],
                      }),
                      ...(_row["Ativos"] !== undefined && {
                        Ativos: _row["Ativos"],
                      }),
                    }))}
                    signed_by={me.username}
                    filter={filter}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="mt-2" style={{ zIndex: 10, position: "relative" }}>
            <Col sm={3}>
              <span className="lince-input_label">Tipo de Resultados</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["Tipo de Resultados"]}
                options={[
                  { label: "Aceite Virtual", value: "Aceite Virtual" },
                  { label: "Ativos", value: "Ativos" },
                  { label: "Contrato Assinado", value: "Contrato Assinado" },
                  { label: "Sem financeiro", value: "Sem financeiro" },
                  { label: "Por Pacote", value: "Por Pacote" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    "Tipo de Resultados": e.value,
                  });
                }}
              />
            </Col>
            <Col sm={3}>
              <span className="lince-input_label">Turma</span>
              <Slct
                className="w-100"
                options={groups}
                placeholder="..."
                value={filter["Turma"].value}
                onChange={e => {
                  setFilter({
                    ...filter,
                    Turma: e,
                  });
                }}
              />
            </Col>
            <Col sm={3}>
              <span className="lince-input_label">Acesso</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["acesso"]}
                options={[
                  { label: "Todos", value: "" },
                  { label: "Autorizado", value: "1" },
                  { label: "Revogado", value: "0" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    acesso: e.value,
                  });
                }}
              />
            </Col>
            <Col sm={3}>
              <span className="lince-input_label">Vinculo</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["vinculo"]}
                options={[
                  { label: "Todos", value: "" },
                  { label: "Ativo", value: "0" },
                  { label: "Encerrado", value: "1" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    vinculo: e.value,
                  });
                }}
              />
            </Col>
          </Row>
          <Row className="mt-2" style={{ zIndex: 9, position: "relative" }}>
            <Col sm={3}>
              <span className="lince-input_label">Comissão</span>
              <Slct
                className="w-100"
                placeholder="..."
                value={filter["comissao"]}
                options={[
                  { label: "Todos", value: "" },
                  { label: "Sim", value: "1" },
                  { label: "Não", value: "0" },
                ]}
                onChange={e => {
                  setFilter({
                    ...filter,
                    comissao: e.value,
                  });
                }}
              />
            </Col>
          </Row>
          {!loading ? (
            <Row>
              <Col>
                <ChartsBar reports={reports.data} title={reports.title} type={reports.type} />
                {reports.table && (
                  <>
                    <TableResponsive
                      className="mt-4"
                      table={{
                        head: [
                          { data: "Formando" },
                          { data: "Turma" },
                          { data: "Criado" },
                          { data: "Comissão" },
                          { data: "Acesso" },
                          { data: "Vinculo" },
                          ...(filter["Tipo de Resultados"] === "Aceite Virtual"
                            ? [
                                { data: "Aceite Virtual" },
                                {
                                  data: (
                                    <span
                                      onClick={() => {
                                        setdateOrder(!dateOrder);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span>Data do Aceite</span>
                                      <span className="simple-ico ml-2">
                                        <IcArrow direction={!dateOrder ? "bottom" : "top"} />
                                      </span>
                                    </span>
                                  ),
                                },
                              ]
                            : []),
                          ...(filter["Tipo de Resultados"] === "Sem financeiro"
                            ? [{ data: "Financeiro Lançado" }]
                            : []),
                          ...(filter["Tipo de Resultados"] === "Por Pacote"
                            ? [{ data: "Pacotes" }, { data: "Eventos Avulsos" }]
                            : []),
                          ...(filter["Tipo de Resultados"] === "Contrato Assinado"
                            ? [
                                { data: "Contrato Assinado" },
                                {
                                  data: (
                                    <span
                                      onClick={() => {
                                        setdateOrder(!dateOrder);
                                      }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <span>Data do Contrato</span>
                                      <span className="simple-ico ml-2">
                                        <IcArrow direction={!dateOrder ? "bottom" : "top"} />
                                      </span>
                                    </span>
                                  ),
                                },
                              ]
                            : []),
                        ],
                        body:
                          reports?.table
                            ?.sort((__a, __b) => {
                              let _key =
                                filter["Tipo de Resultados"] === "Aceite Virtual"
                                  ? "Data do Aceite"
                                  : filter["Tipo de Resultados"] === "Contrato Assinado"
                                    ? "Data do Contrato"
                                    : null;
                              if (!dateOrder) {
                                return new Date(__a[_key]) > new Date(__b[_key]);
                              }
                              return new Date(__a[_key]) < new Date(__b[_key]);
                            })
                            ?.map(__report => ({
                              data: [
                                { element: __report["Formando"] },
                                { element: __report["Turma"] },
                                { element: formatDate(__report["Criado"], 1) },
                                {
                                  element: (
                                    <div style={{ textAlign: "left" }}>
                                      <StatusFlag
                                        style={{
                                          backgroundColor: `var(--color-cycle-${__report.colorComissio})`,
                                        }}
                                        status={__report["Comissao"]}
                                      />
                                    </div>
                                  ),
                                },
                                {
                                  element: (
                                    <div style={{ textAlign: "left" }}>
                                      <StatusFlag
                                        style={{
                                          backgroundColor: `var(--color-cycle-${__report.colorActive})`,
                                        }}
                                        status={__report["Acesso"]}
                                      />
                                    </div>
                                  ),
                                },
                                {
                                  element: (
                                    <div style={{ textAlign: "left" }}>
                                      <StatusFlag
                                        style={{
                                          backgroundColor: `var(--color-cycle-${__report.colorCancel})`,
                                        }}
                                        status={__report["Vinculo"]}
                                      />
                                    </div>
                                  ),
                                },
                                ...(filter["Tipo de Resultados"] === "Aceite Virtual"
                                  ? [
                                      {
                                        element: (
                                          <div style={{ textAlign: "center" }}>
                                            <StatusFlag
                                              style={{
                                                backgroundColor: `var(--color-cycle-${__report.color})`,
                                              }}
                                              status={__report["Aceite Virtual"]}
                                            />
                                          </div>
                                        ),
                                      },
                                      {
                                        element:
                                          __report["Data do Aceite"] &&
                                          __report["Data do Aceite"] !== "0000-00-00 00:00:00"
                                            ? formatDate(__report["Data do Aceite"], 1)
                                            : "-",
                                      },
                                    ]
                                  : []),
                                ...(filter["Tipo de Resultados"] === "Sem financeiro"
                                  ? [
                                      {
                                        element: (
                                          <div style={{ textAlign: "center" }}>
                                            <StatusFlag
                                              style={{
                                                backgroundColor: `var(--color-cycle-${__report.colorFinancial})`,
                                              }}
                                              status={__report["Financeiro Lançado"]}
                                            />
                                          </div>
                                        ),
                                      },
                                    ]
                                  : []),
                                ...(filter["Tipo de Resultados"] === "Por Pacote"
                                  ? [
                                      {
                                        element: __report["Pacotes"],
                                      },
                                      {
                                        element: __report["Eventos Avulsos"],
                                      },
                                    ]
                                  : []),
                                ...(filter["Tipo de Resultados"] === "Contrato Assinado"
                                  ? [
                                      {
                                        element: (
                                          <div style={{ textAlign: "center" }}>
                                            <StatusFlag
                                              style={{
                                                backgroundColor: `var(--color-cycle-${__report.color})`,
                                              }}
                                              status={__report["Contrato Assinado"]}
                                            />
                                          </div>
                                        ),
                                      },
                                      {
                                        element:
                                          __report["Data do Contrato"] &&
                                          __report["Data do Contrato"] !== "0000-00-00 00:00:00"
                                            ? formatDate(__report["Data do Contrato"], 1)
                                            : "-",
                                      },
                                    ]
                                  : []),
                              ],
                              border: `var(--color-cycle-${__report.color})`,
                              link: `/trainees/edit/${__report["Id"]}`,
                            })) || [],
                      }}
                    />
                  </>
                )}
              </Col>
            </Row>
          ) : (
            <div className="mt-2">
              <Loading />
            </div>
          )}
        </Content>
      </Main>
    </PrintPage>
  );
}
